import React, { useState, useEffect, useRef } from "react";
import api from "./api/api";
import { Box, Grid, IconButton, Paper, TextField } from "@mui/material";
import { DataGridPro, GridToolbarContainer, GridToolbarQuickFilter, itIT } from "@mui/x-data-grid-pro";
import { Edit } from "@mui/icons-material";
import { ToastContainer, toast, Slide } from "react-toastify";
import { FaFileMedical } from "react-icons/fa";

const Prompts = () => {
	const [prompts, setPrompts] = useState([]);
	const [prompt, setPrompt] = useState("");
	const rank = Number(sessionStorage.getItem("rank"));
	const renderWrappedCell = (value) => <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", lineHeight: 1.4 }}>{value}</span>;
	const highlightPlaceholders = (text = "") => {
		const parts = [];
		const regex = /{{(.*?)}}/g;
		let lastIndex = 0;

		text.replace(regex, (match, inner, offset) => {
			if (offset > lastIndex) {
				parts.push(<span key={`${offset}-text`}>{text.slice(lastIndex, offset)}</span>);
			}
			parts.push(
				<span
					key={`${offset}-ph`}
					style={{
						backgroundColor: "rgba(255, 225, 130, 0.45)",
						border: "1px dashed rgba(201, 147, 23, 0.7)",
						borderRadius: "6px",
						padding: "0 6px",
						margin: "0 2px",
						fontWeight: 600,
						color: "#8a4b0f",
						fontFamily: "monospace",
					}}
				>
					{match}
				</span>
			);
			lastIndex = offset + match.length;
		});

		if (lastIndex < text.length) {
			parts.push(<span key={`${lastIndex}-end`}>{text.slice(lastIndex)}</span>);
		}

		return parts.length ? parts : [text];
	};

	const renderPromptCell = (params) => {
		const value = params.value || "";
		return <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", lineHeight: 1.4 }}>{highlightPlaceholders(value)}</div>;
	};

	const CustomToolbar = () => (
		<GridToolbarContainer>
			<Grid container direction="row" alignItems="center" justifyContent="flex-start" sx={{ columnGap: 2, margin: { xs: 2, md: 1 } }}>
				<GridToolbarQuickFilter
					placeholder="Cerca per area, obiettivo o testo prompt..."
					sx={{
						"& .MuiInputBase-input": { color: "var(--brand-dark)" },
						"& .MuiInputBase-root": { color: "var(--brand-dark)" },
					}}
				/>
			</Grid>
		</GridToolbarContainer>
	);

	const columns = [
		{
			field: "",
			headerName: "Azioni",
			width: 70,
			align: "center",
			headerAlign: "center",
			renderCell: (params) => (
				<IconButton
					onClick={async () => {
						await setPrompt(params.row);
						document.getElementById("Edit").click();
					}}
					sx={{ color: "var(--brand-dark)" }}
				>
					<Edit />
				</IconButton>
			),
		},
		{
			field: "Phase",
			headerName: "Area",
			flex: 1,
			align: "center",
			headerAlign: "center",
			renderCell: (params) => renderWrappedCell(params.value),
		},
		{
			field: "Objective",
			headerName: "Obbiettivo",
			flex: 1,
			align: "center",
			headerAlign: "center",
			renderCell: (params) => renderWrappedCell(params.value),
		},
		{
			field: "Input",
			headerName: "Prompt",
			flex: 1,
			align: "center",
			headerAlign: "center",
			renderCell: renderPromptCell,
		},
	];

	useEffect(() => {
		if (rank === 1) {
			loadPrompts();
		}
	}, [rank]);

	const loadPrompts = async () => {
		try {
			const responsePrompts = await api.get("prompts", {
				params: { dType: "all", includeAll: false },
			});
			setPrompts(responsePrompts.data.data);
		} catch (error) {
			toast.error("Impossibile caricare i prompt, riprova.");
		}
	};

	if (rank !== 1) {
		return (
			<div className="w-full h-full flex items-center justify-center">
				<div
					className="shadow-lg ring-1 ring-black/10 backdrop-blur-md p-6 text-white text-center max-w-xl"
					style={{ background: "linear-gradient(135deg, rgba(35,100,174,0.3), rgba(39,55,62,0.5))" }}
				>
					<h2 className="text-2xl font-semibold mb-2 text-white">Accesso limitato</h2>
					<p className="text-base font-light text-white/90">Solo gli amministratori possono gestire i prompt.</p>
				</div>
			</div>
		);
	}

	return (
		<>
			<Grid container spacing={2} sx={{ color: "var(--brand-text)" }}>
				<Grid item xs={12}>
					<Modal operazione={"New"} loadPrompts={loadPrompts} highlightPlaceholders={highlightPlaceholders} />
					<Modal
						operazione={"Edit"}
						prompt={prompt}
						loadPrompts={loadPrompts}
						highlightPlaceholders={highlightPlaceholders}
					/>
				</Grid>
				<Grid item xs={12}>
					<Paper
						elevation={3}
						sx={{
							padding: "12px",
							marginTop: "10px",
							background: "linear-gradient(135deg, rgba(141,196,235,0.35), rgba(35,100,174,0.25))",
							border: "1px solid var(--brand-border)",
						}}
					>
						<Box sx={{ width: "100%", height: "80vh" }} className="MyBox">
							<DataGridPro
								localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
								rows={prompts}
								columns={columns}
								getRowHeight={() => "auto"}
								sx={{
									"& .MuiDataGrid-cell": { alignItems: "flex-start", paddingTop: 1, paddingBottom: 1, whiteSpace: "normal", color: "var(--brand-text)" },
									"& .MuiDataGrid-columnHeaders": { fontWeight: 700, backgroundColor: "var(--brand-dark)", color: "white" },
									"& .MuiToolbar-root": { color: "var(--brand-text)" },
									"& .MuiInputBase-root": { color: "var(--brand-text)" },
									"& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--brand-border)" },
								}}
								initialState={{
									pagination: {
										paginationModel: {
											pageSize: 5,
										},
									},
								}}
								slots={{ toolbar: CustomToolbar }}
								checkboxSelection
								disableRowSelectionOnClick
								getRowId={(r) => r.id}
							/>
						</Box>
					</Paper>
				</Grid>
			</Grid>
		</>
	);
};

export default Prompts;

const Modal = (props) => {
	const [prompt, setPrompt] = useState({ Phase: "", Objective: "", Input: "" });
	const modalOverlay = useRef();
	const modal = useRef();
	const highlight = props.highlightPlaceholders || ((t) => t);
	const editableRef = useRef(null);

	const toHighlightedHTML = (text = "") => {
		const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
		return escape(text).replace(/{{(.*?)}}/g, (match) => {
			return `<span style="
				background-color: rgba(255, 225, 130, 0.45);
				border: 1px dashed rgba(201, 147, 23, 0.7);
				border-radius: 6px;
				padding: 0 6px;
				margin: 0 2px;
				font-weight: 600;
				color: #8a4b0f;
				font-family: monospace;
			">${escape(match)}</span>`;
		});
	};

	useEffect(() => {
		if (editableRef.current) {
			editableRef.current.innerHTML = prompt.Input ? toHighlightedHTML(prompt.Input) : '<span style="color:#9ca3af;">Inserisci il prompt con i segnaposto {{...}}</span>';
		}
	}, [prompt.Input]);

	const handleClickOpen = () => {
		if (props.operazione === "New") {
			setPrompt({ Phase: "", Objective: "", Input: "" });
		} else {
			setPrompt(props.prompt);
		}
		modalOverlay.current.classList.remove("hidden");
		setTimeout(() => {
			modal.current.classList.remove("opacity-0");
			modal.current.classList.remove("-translate-y-full");
		}, 200);
	};

	const closeButton = () => {
		modalOverlay.current.classList.add("hidden");
		modal.current.classList.add("opacity-0");
		modal.current.classList.add("-translate-y-full");
	};

	const handleChangeData = (e) => {
		let p = { ...prompt };

		p[e.target.name] = e.target.value;

		setPrompt(p);
	};

	const handleSave = async () => {
		try {
			if (props.operazione === "New") {
				await api.post("/prompts", { prompt: prompt });

				toast.success("Prompt inserito con successo!");
			} else {
				await api.put("/prompts", { prompt: prompt });

				toast.success("Prompt modificato con successo!");
			}

			props.loadPrompts();
			closeButton();
		} catch {
			toast.error("Errore durante l'operazione");
		}
	};

	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={3000}
				hideProgressBar={true}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="dark"
				toastStyle={{ backgroundColor: "#060044" }}
				transition={Slide}
			/>
			{props.operazione === "New" ? (
				<button
					type="button"
					onClick={handleClickOpen}
					className="button-prophet"
					style={{
						float: "right",
						borderRadius: "999px",
						background: "linear-gradient(135deg, rgba(35,100,174,0.85), rgba(39,55,62,0.85))",
						display: "inline-flex",
						alignItems: "center",
						justifyContent: "center",
						paddingInline: "14px",
						paddingBlock: "10px",
						gap: "8px",
					}}
				>
					<FaFileMedical className="text-white" />
					<span className="text-white text-sm md:text-base">Crea nuovo</span>
				</button>
			) : (
				<button
					type="button"
					style={{ display: "none" }}
					id="Edit"
					onClick={handleClickOpen}
					className="button-prophet"
				>
					Modifica
				</button>
			)}
			<div
				ref={modalOverlay}
				id="overlayModal"
					className={`absolute top-0 left-0 right-0 z-50 w-[100%] p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full bg-gray-900 bg-opacity-60 py-auto hidden `}
					onClick={() => closeButton()}
				>
				<div
					className={`transform  relative w-full min-h-[calc(100%-1rem)] mx-auto my-auto flex items-center justify-center `}
				>
					<div
						id="modal"
						ref={modal}
						onClick={(e) => e.stopPropagation()}
						className={`opacity-0 -translate-y-full transform relative bg-white rounded-lg shadow transition-opacity transition-transform duration-400 max-w-sm md:max-w-screen-lg`}
					>
						{/*  <!-- Modal header --> */}
						<div className="flex items-start justify-center p-4 border-b rounded-t relative bg-gray-50">
							<h3 className="text-xl font-semibold text-gray-900 uppercase">
								{props.operazione === "New" ? "Crea nuovo" : "Modifica prompt"}
							</h3>
							<button
								type="button"
								className="absolute right-3 top-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
								data-modal-hide="staticModal"
								onClick={() => closeButton()}
							>
								X
							</button>
						</div>
						{/*  <!-- Modal body --> space-y-6 overflow-y-auto*/}
						<div className="p-3 max-h-[70vh] overflow-y-auto bg-white space-y-4">
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										fullWidth
										id="outlined-basic"
										variant="outlined"
										label="Area"
										value={prompt.Phase}
										name="Phase"
										onChange={handleChangeData}
										InputLabelProps={{ shrink: true }}
									/>{" "}
								</Grid>
								<Grid item xs={12}>
									<TextField
										fullWidth
										id="outlined-basic"
										variant="outlined"
										label="Obbiettivo"
										value={prompt.Objective}
										name="Objective"
										onChange={handleChangeData}
										InputLabelProps={{ shrink: true }}
									/>{" "}
								</Grid>
								<Grid item xs={12}>
									<div className="flex flex-col gap-2">
										<label className="text-sm font-medium text-gray-700">Prompt</label>
										<div
											contentEditable
											suppressContentEditableWarning
											onInput={(e) => {
												setPrompt((p) => ({ ...p, Input: e.currentTarget.innerText }));
											}}
											onBlur={(e) => {
												// normalizziamo eventuali div/span in semplice testo
												setPrompt((p) => ({ ...p, Input: e.currentTarget.innerText }));
											}}
											ref={editableRef}
											style={{
												minHeight: 140,
												border: "1px solid #d1d5db",
												borderRadius: 8,
												padding: 12,
												whiteSpace: "pre-wrap",
												wordBreak: "break-word",
												outline: "none",
											}}
											className="focus:ring-2 focus:ring-indigo-400 bg-white"
											>
												{highlight(prompt.Input)}
											</div>
									</div>
								</Grid>
							</Grid>
						</div>
						{/* <!-- Modal footer --> */}
						<div className="flex items-center justify-between py-3 px-4 space-x-4 border-t border-gray-200 rounded-b bg-white">
							<div className="flex flex-nowrap space-x-2"></div>
							<div className="flex flex-nowrap space-x-2">
								<button
									type="button"
									onClick={handleSave}
									className="button-prophet"
									style={{
										borderRadius: "10px",
										paddingInline: "14px",
										paddingBlock: "10px",
									}}
								>
									Salva
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
